import { createSelector } from 'reselect';
import getCartDeliveryTimeExpected from '@core/reducers/cart/selectors/getCartDeliveryTimeExpected';
import getDistanceVendor from '@shopDetails/selectors/getDistanceVendor';
import getCartShippingAmount from '@core/reducers/cart/selectors/getCartShippingAmount';
import getCartMinDeliveryAmount from '@core/reducers/cart/selectors/getCartMinDeliveryAmount';
import getCartIsPickUp from '@core/reducers/cart/selectors/getCartIsPickUp';
import getUseLiveOrderTracking from '@core/reducers/shop/selectors/getUseLiveOrderTracking';

const getShopInformationPickup = createSelector(
  getCartDeliveryTimeExpected,
  getDistanceVendor,
  getCartShippingAmount,
  getCartMinDeliveryAmount,
  getCartIsPickUp,
  getUseLiveOrderTracking,
  (
    cartDeliveryTime,
    distanceVendor,
    cartShippingAmount,
    cartMinDeliveryAmount,
    isPickup,
    useLiveOrderTracking,
  ) => {
    const information = {
      pickup: {
        time: { maxMinutes: cartDeliveryTime?.maxMinutes },
        distance: distanceVendor?.distance,
        duration: distanceVendor?.duration,
        useLiveOrderTracking,
      },
      delivery: {
        time: {
          minMinutes: cartDeliveryTime?.minMinutes,
          maxMinutes: cartDeliveryTime?.maxMinutes,
        },
        shipping: cartShippingAmount,
        min: cartMinDeliveryAmount,
        useLiveOrderTracking,
      },
    };

    if (isPickup) {
      information.delivery.time = { minMinutes: null, maxMinutes: null };
    } else {
      information.pickup.time = { maxMinutes: null, minMinutes: null };
    }

    return information;
  },
);

export default getShopInformationPickup;
